import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";

@Component({
  standalone: false,
  selector: "app-final",
  templateUrl: "./final.component.html"
})
export class FinalComponent implements OnInit {

  constructor(
    private title: Title,
  ) { }

  ngOnInit() {
    this.title.setTitle("Prestação de contas final");
  }

}